var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewProjectIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#0828B7",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6798_84917",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6797,
    y: 12.347,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6798_84917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0797 33.347L26.6797 31.947L28.2547 30.347L26.6797 28.772L28.0797 27.347L29.6797 28.947L31.2547 27.347L32.6797 28.772L31.0797 30.347L32.6797 31.947L31.2547 33.347L29.6797 31.772L28.0797 33.347ZM17.6797 31.347C17.963 31.347 18.2005 31.2512 18.3922 31.0595C18.5839 30.8678 18.6797 30.6303 18.6797 30.347C18.6797 30.0637 18.5839 29.8262 18.3922 29.6345C18.2005 29.4428 17.963 29.347 17.6797 29.347C17.3964 29.347 17.1589 29.4428 16.9672 29.6345C16.7755 29.8262 16.6797 30.0637 16.6797 30.347C16.6797 30.6303 16.7755 30.8678 16.9672 31.0595C17.1589 31.2512 17.3964 31.347 17.6797 31.347ZM17.6797 33.347C16.8464 33.347 16.138 33.0553 15.5547 32.472C14.9714 31.8887 14.6797 31.1803 14.6797 30.347C14.6797 29.5137 14.9714 28.8053 15.5547 28.222C16.138 27.6387 16.8464 27.347 17.6797 27.347C18.2964 27.347 18.8589 27.5178 19.3672 27.8595C19.8755 28.2012 20.2464 28.6637 20.4797 29.247C21.1297 29.0637 21.6589 28.7053 22.0672 28.172C22.4755 27.6387 22.6797 27.0303 22.6797 26.347V22.347C22.6797 20.9637 23.1672 19.7845 24.1422 18.8095C25.1172 17.8345 26.2964 17.347 27.6797 17.347H28.8297L27.2547 15.772L28.6797 14.347L32.6797 18.347L28.6797 22.347L27.2547 20.947L28.8297 19.347H27.6797C26.8464 19.347 26.138 19.6387 25.5547 20.222C24.9714 20.8053 24.6797 21.5137 24.6797 22.347V26.347C24.6797 27.5637 24.288 28.6345 23.5047 29.5595C22.7214 30.4845 21.7297 31.0553 20.5297 31.272C20.3297 31.8887 19.9672 32.3887 19.4422 32.772C18.9172 33.1553 18.3297 33.347 17.6797 33.347ZM16.0797 21.347L14.6797 19.947L16.2547 18.347L14.6797 16.772L16.0797 15.347L17.6797 16.947L19.2547 15.347L20.6797 16.772L19.0797 18.347L20.6797 19.947L19.2547 21.347L17.6797 19.772L16.0797 21.347Z",
    fill: "#122961"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProjectIcon);
export default __webpack_public_path__ + "static/media/new_project_icon.dba21ef24b12e98e9e0a9654afdfcb3a.svg";
export { ForwardRef as ReactComponent };